export const faqs = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago, recibirás un email con el enlace de descarga. Los 6 tomos + 6 bonos son archivos PDF que puedes descargar en tu computadora, tablet o teléfono. Acceso de por vida, sin suscripción.'
  },
  {
    q: '¿Sirve si soy profe nueva o si tengo experiencia?',
    a: 'Sirve para ambas. Si eres nueva, los tomos te dan la estructura que te falta. Si tienes experiencia, los bonos te hacen 10x más eficiente. El 40% de nuestras usuarias son profesoras nuevas. El 60% son experimentadas que quieren mejorar.'
  },
  {
    q: '¿Qué incluye exactamente el pack completo por 17,99€?',
    a: '6 Tomos (240 ejercicios detallados) + 6 Bonos (Planificador, Cues, Correcciones, Progresiones, Selector, Adaptaciones). Todo en PDF descargable. Sin suscripción. Acceso de por vida.'
  },
  {
    q: '¿Qué diferencia hay con otros materiales de Pilates que ya existen?',
    a: 'Cada ficha tiene correcciones exactas y cues listos, incluye un sistema completo de planificación, está diseñado por profesoras experimentadas — no por "expertos" que no enseñan — tiene garantía de 7 días y el 98% de quienes lo compran se queda.'
  },
  {
    q: '¿Sirve para grupos con niveles mezclados?',
    a: 'Sí. Cada ejercicio tiene regresión (para iniciales) y progresión (para avanzadas). El Bono de Progresiones/Regresiones te enseña exactamente cómo adaptar en tiempo real. Puedes enseñar a 3 niveles simultáneamente sin improvisar.'
  },
  {
    q: '¿Vale la pena si ya planifico bien mis clases?',
    a: 'Probablemente sí. Incluso profesoras que planifican bien ahorran de 5 a 8 horas semanales con esto. Además, los bonos (Cues, Correcciones, Seguridad) son herramientas que la mayoría no tiene.'
  },
  {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas de crédito (Visa, Mastercard, American Express). El pago es seguro, se procesa en la moneda de tu país y no tiene comisiones ocultas.'
  },
  {
    q: '¿Sirve para dar clases online?',
    a: 'Totalmente. Muchas profesoras usan esto para clases online, presenciales e híbridas. El Bono del Planner te ayuda a organizar ambos formatos.'
  },
  {
    q: '¿Incluye videos?',
    a: 'No. Es PDF descargable. Cada ejercicio tiene descripción detallada e imagen de referencia. Está diseñado así porque muchas profesoras lo usan impreso en clase. Si prefieres videos, este no es tu producto.'
  },
  {
    q: '¿Funciona para adultos mayores, embarazadas o lesiones?',
    a: 'Sí. El Tomo 6 está completamente dedicado a poblaciones especiales: embarazo, post-parto, tercera edad, hernias, escoliosis, osteoporosis y más. Es el tomo más completo en materia de seguridad.'
  }
];
